module.exports = __webpack_public_path__ + "static/media/Lecture2.e0f1afd8.jpeg";